<template>
  <div class="bg bglight">
    <div
      class="bghalf hidden-xs"
      :style="backgroundStyle"
      v-if="!isBackgroundLoading"
    ></div>
    <div
      class="bghalf hidden-xs"
      v-if="isBackgroundLoading"
      style="background-color: #f5f5f5; display: flex; align-items: center; justify-content: center;"
    >
      <p>Bild wird geladen...</p>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-offset-6 col-md-6 col-sm-12">
          <div class="bglight padding darkcolor right">
            <div class="bottom0 top15 justify" v-html="mainTextHtml"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useBackgroundImageLoader } from "../../composables/index.js";
import { onMounted, watch, computed } from "vue";
import { normalizeInvertedStrongParagraphs } from "../../lib/normalizeCmsHtml.js";

export default {
  props: {
    content: Object, // Content object with content property
    backgound_image: Object,
  },
  setup(props) {
    const { backgroundStyle, isBackgroundLoading, loadBackgroundImage } = useBackgroundImageLoader();

    const mainTextHtml = computed(() =>
      normalizeInvertedStrongParagraphs(props.content?.main_text || '')
    );

    const loadImage = async () => {
      if (props.backgound_image) {
        await loadBackgroundImage(props.backgound_image);
      }
    };

    onMounted(() => {
      loadImage();
    });

    // Watch für Änderungen am backgound_image prop
    watch(() => props.backgound_image, () => {
      loadImage();
    }, { deep: true });

    return {
      backgroundStyle,
      isBackgroundLoading,
      mainTextHtml
    };
  }
};
</script>

<style scoped lang="scss">
.justify :deep(p) {
  margin: 0 0 1em;
}

.justify :deep(p:last-child) {
  margin-bottom: 0;
}

.justify :deep(strong) {
  font-weight: 700;
  font-synthesis: weight;
}

.justify :deep(p > strong:only-child),
.justify :deep(p:last-child strong) {
  display: block;
  margin-top: 1em;
}
</style>
